/**
 * FreeSpins Class
 *
 * this module manages both freespins modes it inherits from spin functions
 *
 */

freespins = (function () {
  var _inFreeSpins = false;
  var _stopOffsets;
  var _currentMsgBox;
  var _msgBoxFinalPos = {};
  var _msgBoxStartPos = { x: 0, y: -500 };
  var _msgBoxIntroCallback;
  var _msgBoxOutroCallback;
  var _awardFreespinsTask;
  var _endFreespinsTask;

  var _initialDroppingFS = 0;
  var _bonusAnimsPlayed = false;

  var _freeSpinsMeter;
  let _gambleSpin;

  function initialise() {
    _gambleIntro = resourceManager.get("gambleIntroContainer:GambleIntro");
    _gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");
    _freeSpinsMeter = resourceManager.get("freeSpinsMeter");
    _spinButton = resourceManager.get("buttonContainer:buttonBar:spinButton");
    multiplierViewLeft = resourceManager.get(
      "multiplierViewLeft:MultiplierViewLeft"
    );
    multiplierViewRight = resourceManager.get(
      "multiplierViewRight:MultiplierViewRight"
    );
  }

  function canEnableSpin() {
    return freespins.stateMachine.ActiveStateName === "READY_TO_START";
  }

  function canShowSpin() {
    return freespins.stateMachine.ActiveStateName === "READY_TO_START";
  }

  function canEnableSkip() {
    return freespins.stateMachine.ActiveStateName === "PAYWINS";
  }

  function canShowSkip() {
    return freespins.stateMachine.ActiveStateName === "PAYWINS";
  }

  // this just flips the layout between freeSpins and normal
  function freespinsMode(bool) {
    _inFreeSpins = bool;
  }

  function awardFreeSpinsComplete() {
    //slotMachine.selectReelMode("freespins");
    //musicManager.onFreespinsStart();
    _awardFreespinsTask.leave();
  }

  function onDecisionMade(task, resultCallback, gambleDecision) {
    if (gambleDecision === "collect") {
      resultCallback({ response: "collect" }, function () {
        task.leave();
      });
    } else {
      resultCallback({ response: "gamble" }, function () {
        task.leave();
      });
    }

    gameController.cancelAutoplay();
  }

  function onFreespinsAwarded(task) {
    // if(_gambleSpin.visible){
    // 	return;
    // }
    // Stop autoplay
    gdk.cancelAutoplay();

    musicManager.onFreespinsIntro();

    // animate the bonus symbols before bringing up the dialog
    let temp = task;
    temp.join();

    var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;

    if (!_bonusAnimsPlayed) {
      for (var i = 0; i < reelManager.reels.length; i++) {
        for (var j = 0; j < 3; j++) {
          if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
            AllWaysPayWinAnimator.animateSymbolWithoutBorder("Bonus", i, j);
          }
        }
      }
    }

    soundManager.play("bonusWon");
    _bonusAnimsPlayed = true;

    timerManager.addTimer(1950, undefined, function () {
      showDialog(temp);
    });
  }

  function showDialog(task) {
    let temp = task;

    let multiplierLeft = resourceManager.get(
      "multiplierViewLeft:MultiplierViewLeft"
    );

    if (multiplierLeft.getMultiplier()[0] !== 1) {
      multiplierLeft.resetMultiplier();
    }

    let multiplierRight = resourceManager.get(
      "multiplierViewRight:MultiplierViewRight"
    );

    if (multiplierRight.getMultiplier()[0] !== 1) {
      multiplierRight.resetMultiplier();
    }

    if (task.data.numScatters === 5 || !gdk.getPlatformAllowsGamble()) {
      // auto collect max bonus
      onDecisionMade(temp, temp.data.resultCallback, "collect");

      hideReel();

      return;
    }

    // mid gamble
    if (_gambleSpin.visible) {
      _gambleIntro.reactivate(
        task.data.numFreeSpins,
        task.data.winChance,
        task.data.loseChance,
        onDecisionMade.bind(this, temp, temp.data.resultCallback)
      );
    } else {
      // resets free spins index - base on scatters won
      // 3 scatters start at 0
      // 4 scatter - 1
      // 5 scatters - shouldn't gamble
      _gambleSpin.resetGambleSpin(task.data.numScatters - 3);

      let initialDelay = 0;
      timerManager.addTimer(initialDelay, undefined, function () {
        _gambleIntro.start(
          task.data.numFreeSpins,
          task.data.winChance,
          task.data.loseChance,
          task.data.possibleValues,
          task.data.numScatters - 3,
          function () {
            setupFsScene(task.data.numFreeSpins);
          },
          onDecisionMade.bind(this, temp, temp.data.resultCallback)
        );
      });
    }
  }

  function hideReel() {
    let reels = resourceManager.get("slotContainer:reelContainer");

    var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
    let animStrips = [];

    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      var animStrip = resourceManager.get(
        reelManager.reels[reelID].linkedAnimations[0].name
      );
      animStrips.push(animStrip);
    }

    timerManager.addTimer(
      300,
      function (progress) {
        animStrips.forEach((strip) => {
          strip.alpha = 1 - progress;
        });

        reels.alpha = 1.0 - progress;
      },
      function () {
        reels.alpha = 0;

        animStrips.forEach((strip) => {
          strip.hideAllAnimations();
        });

        for (var i = 0; i < reelManager.reels.length; i++) {
          for (var j = 0; j < 3; j++) {
            if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
              gameData.reels[i].showSymbol(j, true);
            }
          }
        }
      }
    );
  }

  function onFreespinsStart(task) {
    let temp = task;
    temp.join();

    _gambleSpin.visible = false;

    musicManager.onFreespinsIntro();

    _freeSpinsMeter.resetMeter();
    _freeSpinsMeter.addSpins(task.data.freeSpinsAwarded);

    _gambleIntro.doShowIntro(task.data.freeSpinsAwarded, function () {
      let reels = resourceManager.get("slotContainer:reelContainer");
      timerManager.addTimer(
        0,
        function (progress) {
          reels.alpha = progress;
        },
        function () {
          reels.alpha = 1.0;
        }
      );
      temp.leave();
      temp = undefined;
    });
  }

  function onFreespinsStartDead(task) {
    _winnings = 0;

    musicManager.onFreespinsStart();

    freespinsMode(true);
    hideSpinButton();
    startSpins();
  }

  function startSpins() {
    startGame();

    gdk.getNextGameOutcome(function () {});
  }

  function startGame() {
    gameController.resetWinnings();

    resourceManager.get("trail:TrailContainer").trailRunEndedFS();

    gameData.numPops = 0;

    freespins.spinTask = undefined;

    _freeSpinsMeter.useSpin();

    freespins.stateMachine.switchState("CLEAR_REELS");
  }

  function hideSpinButton() {
    gameData.inputOverlord.setState("freespinsEnabled");
  }

  function onFreespinsAwardedEnd() {
    showSpinButton();
    gdk.getNextGameOutcome(function () {});
  }

  function showSpinButton() {
    _spinButton.visible = true;
  }

  function onMultiplierEvent(task) {
    if (task.data.nextMultiplier === -1 && task.data.currentStep > 1) {
      return;
    }

    freespins.MultiplierTask = task;
  }

  function setupFsScene(numFs) {
    hideReel();
  }

  function onFreespinsDataEvent(task) {
    _spinsRemaining = task.num;
    startGame();
    gdk.getNextGameOutcome(function () {});
  }

  function onGambleResultEvent(task) {
    let temp = task;
    temp.join();
    _gambleSpin.spinToResult(task.data.won, function () {
      temp.leave();
      temp = undefined;
    });
  }

  function onGambleResultEventDead(task) {
    if (!task.won) {
      _bonusAnimsPlayed = false;

      musicManager.onFreespinsLostGambleEnd();
      let reels = resourceManager.get("slotContainer:reelContainer");
      reels.alpha = 1.0;
    }
  }

  function onFreespinsEndEvent(task) {
    _endFreespinsTask = task;
    _endFreespinsTask.join();

    _bonusAnimsPlayed = false;

    let freeSpinsWin = _endFreespinsTask.data.finalFsWinnings;
    let totalWinnings = _endFreespinsTask.data.totalWinnings;

    let isCapped = _endFreespinsTask.data.isCapped;

    if (isCapped) {
      var amount = totalWinnings - gameData.winningsMeter.value;
      gameData.winningsMeter.countUp(amount, 500);
    } else {
      gameData.winningsMeter.set(totalWinnings);
    }

    // Put in a pause then show a big win or free spins end
    timerManager.addTimer(1000, undefined, function () {
      doFreeSpinsOutroDialog(freeSpinsWin);
    });
  }

  function doFreeSpinsOutroDialog(freeSpinsWin) {
    resourceManager.get("trail:TrailContainer").resetTrail();
    resourceManager.getContainer("freeSpinsContainer").visible = false;
    // Show outro
    _freeSpinsIntroOutro = resourceManager.get(
      "freeSpinsIntroOutroContainer:FreeSpinsIntroOutro"
    );
    _freeSpinsIntroOutro.showOutro(freeSpinsWin, doBigWinCheck);

    soundManager.play("freeSpinsEnd");

    musicManager.onSymbolWinlineStart();
  }

  function doBigWinCheck() {
    let totalWinnings = _endFreespinsTask.data.totalWinnings;
    let isCapped = _endFreespinsTask.data.isCapped;

    _bigWin = resourceManager.get("bigWin");
    let isBigWin = _bigWin.willTriggerBigWin(totalWinnings);

    if (isBigWin) {
      _bigWin.start(totalWinnings, endFreespins, isCapped);
    } else {
      endFreespins();
    }
  }

  function endFreespins() {
    resourceManager.getContainer("fsBackgroundContainer").visible = false;
    resourceManager.getContainer("backgroundContainer").visible = true;
    resourceManager.get("trail:TrailContainer").resetTrail();

    freespinsMode(false);
    gameData.inputOverlord.setState("enabled");
    freespins.stateMachine.switchState("READY_TO_START");
    musicManager.wasInFreeSpins = true;
    musicManager.onFreespinsEnd();
    _endFreespinsTask.leave();
  }

  ////////////////////////////////////////////
  // define freespins Object to be returned //
  ////////////////////////////////////////////

  freespins = Object.create(spinFunctions);

  Object.defineProperties(freespins, {
    initialise: {
      value: initialise,
    },
    freespinsMode: {
      value: freespinsMode,
    },
    inFreespins: {
      get: function () {
        return _inFreeSpins;
      },
    },
    onFreespinsAwarded: {
      value: onFreespinsAwarded,
    },
    onFreespinsAwardedEnd: {
      value: onFreespinsAwardedEnd,
    },
    onFreespinsStart: {
      value: onFreespinsStart,
    },
    onFreespinsStartDead: {
      value: onFreespinsStartDead,
    },
    onFreespinsDataEvent: {
      value: onFreespinsDataEvent,
    },
    onFreespinsEndEvent: {
      value: onFreespinsEndEvent,
    },
    onGambleResultEvent: {
      value: onGambleResultEvent,
    },
    onGambleResultEventDead: {
      value: onGambleResultEventDead,
    },
    canEnableSpin: {
      value: canEnableSpin,
    },
    canShowSkip: {
      value: canShowSkip,
    },
    canEnableSkip: {
      value: canEnableSkip,
    },
    canShowSpin: {
      value: canShowSpin,
    },
    startGame: {
      value: startGame,
    },
  });

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(freespins);

  ///
  freespins.stateMachine.addState("WAITING_FOR_SERVER", function () {});

  ///
  freespins.stateMachine.addState("READY_TO_START", function () {});

  ///
  freespins.initialDropComplete = function (reelID) {
    --_initialDroppingFS;
  };

  freespins.areFreeSpinsActive = function () {
    return freespins._inFreeSpins;
  };

  ///
  freespins.stateMachine.addState("CLEAR_REELS", function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count

    if (freespins.phase.enter()) {
    }

    // ensure we have result data before proceeding - don't clear reels until this is set
    if (freespins.phase.hold()) {
      if (freespins.spinTask !== undefined) {
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      slotMachine.clearReels();

      _initialDroppingFS = gameData.reels.length;
      gameController.resetSymbolCallbackFired();
    }

    if (freespins.phase.hold()) {
      if (_initialDroppingFS === 0) {
        let _positions = freespins.spinTask.data.resultPanel.reelList.map(
          function (reel, index) {
            return reel.symbols.map(function (curr) {
              return curr.value;
            });
          }
        );

        // we need to have a random symbol as the first below which we can drop
        // off the symbol grid when new symbols all cascade in
        // NOTE:  Freespins can't retrigger so make sure no feature symbols are selected
        // Also wild symbols shouldn't be shown so limit to first 8
        let randomBelow = [];
        for (var i = 0; i < gameData.reels.length; i++) {
          randomBelow[i] = getRandom(8);
        }

        let _symbolsAbove = [[0], [0], [0], [0], [0]];
        let _symbolsBelow = [
          [randomBelow[0]],
          [randomBelow[1]],
          [randomBelow[2]],
          [randomBelow[3]],
          [randomBelow[4]],
        ];

        // calculate whether we display landing symbols - this should be empty for free spins
        gameController.calcLandingAnims();

        slotMachine.dropInitialSymbols(
          _symbolsAbove,
          _positions,
          _symbolsBelow
        );
        freespins.phase.step();
      }
    }

    if (freespins.phase.once()) {
      freespins.stateMachine.switchState("REELS_SPINNING");
    }
  });

  freespins.onSpinCompleteFS = function (reelID) {
    freespins.reelsSpinning[reelID] = false;
  };

  freespins.stateMachine.addState("REELS_SPINNING", function () {
    if (freespins.phase.enter()) {
      gameController._receivedResponse = true; // this allows slam stop
      freespins.reelsSpinning = [true, true, true, true, true];
    }

    // don't proceed until all reels have finished spinning
    if (freespins.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (
        var spinningIdx = 0;
        spinningIdx < freespins.reelsSpinning.length;
        spinningIdx++
      ) {
        spinComplete = spinComplete && !freespins.reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        freespins.phase.step();
        gameController._receivedResponse = false;
      }
    }

    if (freespins.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      if (freespins.spinTask) {
        freespins.spinTask.leave();
      }
    }
  });

  freespins.stateMachine.addState("PAYWINS", function () {});

  freespins.stateMachine.addState("PAY_TO_WINNINGS", function () {
    if (freespins.phase.enter()) {
      gameData.winningsMeter.countUp(
        freespins.winsTask.data.totalLineWinnings,
        1000
      );
    }
    if (freespins.phase.hold()) {
      if (!gameData.winningsMeter.Props.isCounting) {
        freespins.winsTask.leave();
      }
    }
  });

  function update(delta) {
    _delta = delta;
    this.stateMachine.update();
  }

  messageBus.subscribe("game:MultiplierEvent", onMultiplierEvent);
  messageBus.subscribe("game:FreeSpinsAwardEvent", onFreespinsAwarded);
  messageBus.subscribe("game:FreeSpinsAwardEventDead", onFreespinsAwardedEnd);
  messageBus.subscribe("game:FreeSpinsStartEvent", onFreespinsStart);
  messageBus.subscribe("game:FreeSpinsStartEventDead", onFreespinsStartDead);
  messageBus.subscribe("game:FreeSpinsDataEventDead", onFreespinsDataEvent);
  messageBus.subscribe("game:FreeSpinsEndEvent", onFreespinsEndEvent);
  messageBus.subscribe("fire_gems:GambleResultEvent", onGambleResultEvent);
  messageBus.subscribe(
    "fire_gems:GambleResultEventDead",
    onGambleResultEventDead
  );
  Reflex.addToUpdate(update.bind(freespins));

  return freespins;
})();
